import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';

type Props = {
  password: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

type State = {
  seePassword: boolean;
};

export const SignUpFormPassword: FC<Props> = ({ password, handleChange }) => {
  const [seePassword, setSeePassword] = useState(false);

  const toggleSeeClearPassword = () => {
    doctrineAnalytics('Account SeePasswordToggle', { source: 'signup' });
    setSeePassword((previous) => !previous);
  };

  return (
    <label htmlFor="input-password" className="signup-form__label">
      <div className="signup-form__label__group">
        <div>
          <FormattedMessage id="signup/routes/user/form/SignUpFormPassword.tsx/1" />{' '}
          <span className="signup-form__label__discreet">
            <FormattedMessage id="signup/routes/user/form/SignUpFormPassword.tsx/2" />
          </span>
        </div>
        <button
          type="button"
          className="signup-form__seebutton"
          onClick={toggleSeeClearPassword}
          data-test-id="toggle-password"
        >
          {seePassword ? 'Masquer' : 'Afficher'}
        </button>
      </div>
      <input
        id="input-password"
        data-test-id="input-password"
        type={seePassword ? 'text' : 'password'}
        name="password"
        value={password}
        onChange={handleChange}
        spellCheck={false}
        required
      />
    </label>
  );
};
